/* eslint-disable react/jsx-no-constructed-context-values */
import { Button, Card, Col, Form, Row, Spin } from 'antd'

import PropTypes from 'prop-types'

import EAReportContext from './Context'
import EAReportDateTimeFilter from './Filters/DateTime'
import adjustDateRange from './Filters/DateTime/utils/adjustDateRange'

const { useForm } = Form

const propTypes = {
  dataRenderer: PropTypes.element,
  disableDate: PropTypes.bool,
  disableTime: PropTypes.bool,
  exportRenderer: PropTypes.element,
  filterRenderer: PropTypes.func,
  loading: PropTypes.bool,
  title: PropTypes.string.isRequired,
  onSubmit: PropTypes.func.isRequired,
  enableInfo: PropTypes.bool,
  infoRenderer: PropTypes.func,
}

const defaultProps = {
  dataRenderer: null,
  disableDate: false,
  disableTime: false,
  exportRenderer: null,
  filterRenderer: () => null,
  loading: false,
  enableInfo: false,
  infoRenderer: () => null,
}

const EAReport = ({
  dataRenderer,
  disableDate,
  disableTime,
  exportRenderer,
  filterRenderer,
  loading,
  title,
  onSubmit,
  enableInfo,
  infoRenderer,
}) => {
  const [form] = useForm()

  return (
    <Spin spinning={loading}>
      <EAReportContext.Provider value={{ title }}>
        <Form
          form={form}
          layout="vertical"
          style={{ marginBottom: 16 }}
          validateMessages={{
            required: 'Campo obrigatório.',
          }}
          onFinish={(filtros) => {
            onSubmit(disableDate ? filtros : adjustDateRange(filtros))
          }}
        >
          <Row gutter={16}>
            <Col span={enableInfo ? 16 : 24}>
              <Card actions={[<Button htmlType="submit">Filtrar</Button>]} title={title}>
                {filterRenderer(form)}

                {disableDate ? null : <EAReportDateTimeFilter disableTime={disableTime} />}
              </Card>
            </Col>
            {enableInfo && infoRenderer && (
              <Col span={8}>
                <Card title="Resumo">{infoRenderer(form)}</Card>
              </Col>
            )}
          </Row>
        </Form>

        {exportRenderer}

        {dataRenderer}
      </EAReportContext.Provider>
    </Spin>
  )
}

EAReport.propTypes = propTypes
EAReport.defaultProps = defaultProps

export default EAReport
